import React, {
    useCallback,
    useEffect,
    useMemo,
    useState,
} from "react";
import { fetchData } from "../../utils/apiUtils";
import Breadcrumb from "../../helper/Breadcrumb";
import TransactionTable from "./TransactionTable";
import { useNavigate } from "react-router-dom";
import TableSearch from "../../Components/TableSearch";
import PerPageSelect from "../../Components/PerPageSelect";
const Transaction = () => {
    const navigator=useNavigate()
    const [loading, setLoading] = useState(true);
    const [transaction, settransaction] = useState([]);
    const [search, setSearch] = useState("");
    const [totalCount, setTotalCount] = useState(0);
    const [currentPage, setCurrentPage] = useState(1);
    const [perPage, setPerPage] = useState(10);
    const totalPages = useMemo(() => Math.ceil(totalCount / perPage), [totalCount, perPage]);


    const fetchTransaction = useCallback(
        async (page = 1, searchQuery = "") => {
            setLoading(true);
            await fetchData(
                "transaction",
                { perPage, pageNo: page, search: searchQuery },
                settransaction,
                setTotalCount,
                setCurrentPage,
                setLoading
            );
        },
        [perPage]
    );

    useEffect(() => {
        const delay = search ? 500 : 0;
        const handler = setTimeout(() => {
            fetchTransaction(currentPage, search);
        }, delay);

        return () => clearTimeout(handler);
    }, [search, perPage]);
    const handlePageClick = (page) => {
        if (page >= 1 && page <= totalPages) {
            fetchTransaction(page);
        }
    };


    const handleRedirect=(orderId)=>{
         navigator(`/order/detail/${orderId}`);
    }
    const breadcrumbdata = [
        { label: "Home", path: "/" },
        { label: "Transactions", path: "*" },
    ];
    return (
            <div className="content-wrapper">
                <div
                    className="page-header mt-5"
                    style={{ display: "flex", justifyContent: "space-between" }}>
                    <h3 className="custom-page-title">Transactions</h3>
                    <Breadcrumb items={breadcrumbdata} />
                </div>

                <div
                    className="d-flex justify-content-between mb-2"
                    style={{ background: "#fff", padding: "10px", marginTop: "-20px" }}>
                    
  <PerPageSelect value={perPage} onChange={setPerPage}/>
                    <div style={{ display: "flex", gap: "20px" }}>
                       <TableSearch value={search} onChange={setSearch} />
                    </div>
                </div>

                <TransactionTable
                    loading={loading}
                    transaction={transaction}
                    currentPage={currentPage}
                    perPage={perPage}
                    totalPages={totalPages}
                    totalCount={totalCount}
                    handlePageClick={handlePageClick}
                    handleRedirect={handleRedirect}
                />
            </div>
    );
};

export default Transaction;
